import React from "react";
import Loader from "../../atoms/Loader/Loader";

interface Props {
  status: string;
  clickFilterSearch?: boolean;
  totalRecords?: number;
}

const HelperLoader: React.FC<Props> = ({ status, totalRecords }) => {
  const renderContent = () => {
    if (status === "Loading" || status === "loading") {
      return <Loader />;
    } else if (!totalRecords) {
      return <div className="no-results">No Results Found</div>;
    }
  };

  return <div>{renderContent()}</div>;
};

export default HelperLoader;
